const FILENAME_MAX_LENGTH = 260;
export const ERROR_EMPTY_FILENAME = 'File name can’t be empty.';
export const ERROR_FILENAME_TOO_LONG = 'File name can’t exceed 260 characters.';
const INVALID_CHAR_REGEX = /[<>:"/\\|?*]/;
export const ERROR_FILENAME_WITH_INVALID_CHARS =
  'File name can’t contain the following characters: < > : " /  | ? *';
const INVALID_ENDING_REGEX = /[.]/;
export const ERROR_FILENAME_INVALID_ENDING = 'File name can’t end with a dot.';

export const extractFileExtension = (filename: string) =>
  filename.includes('.')
    ? filename.substring(filename.lastIndexOf('.'), filename.length)
    : '';

export const fileWithoutExtension = (filename: string) =>
  filename.replace(/\.[^/.]+$/, '');

const isFilenameTooLong = (filename: string) =>
  filename.length > FILENAME_MAX_LENGTH;

const isFilenameWithInvalidCharacters = (filename: string) =>
  INVALID_CHAR_REGEX.test(filename);

const isFilenameWithInvalidEnding = (filename: string) =>
  INVALID_ENDING_REGEX.test(filename);

export const getFilenameErrorMessage = (filename: string) => {
  if (!filename) return ERROR_EMPTY_FILENAME;
  if (isFilenameTooLong(filename)) return ERROR_FILENAME_TOO_LONG;
  if (isFilenameWithInvalidCharacters(filename))
    return ERROR_FILENAME_WITH_INVALID_CHARS;
  if (isFilenameWithInvalidEnding(filename))
    return ERROR_FILENAME_INVALID_ENDING;

  return '';
};
